import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Helper } from '../../common/helper';
import { ToastrService } from 'ngx-toastr';
import { OnlineOfflineService } from '../../../services/online-offline.service';
import { DbContextService } from '../../../services/db-context.service';
import { from, map, of, tap } from 'rxjs';
import { SecurityHelper } from '../../common/securityHelper';
import swal from 'sweetalert2';

@Injectable({
  providedIn: 'root'
})
export class SecurityService {
  constructor(private readonly onlineOfflineService: OnlineOfflineService, private dbxService: DbContextService,
    private toastr: ToastrService, private http: HttpClient) { }

  getUserByShipRole(roleID: any, shipID: any) {
    let paramObject = {
      'roleID': roleID,
      'shipID': shipID
    }

    return this.http.post(Helper.API_URL() + '/api/security/GetUserByShipRole', paramObject);
  }
  getUserByContactID(contactID: any) {

    return this.http.post(Helper.API_URL() + '/api/security/GetUserOrderHandlerByShip', {});
  }

  getShipManagerLogoDirectoryPath() {
    return this.http.post(Helper.API_URL() + '/api/ShipOwner/GetShipsManagerOwnerPhoto', {});
  }

  getShipDetails() {
    return this.http.get(Helper.API_URL() + '/api/maintenance/GetShipsDetails');
  }

  getDepartmentList() {
    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetDepartmentList', {});
  }
  getDepartmentIDNameList() {
    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetDepartmentIDNameList', {});
  }
  getIVIShipDepartmentList() {

    return this.http.post(Helper.API_URL() + '/api/Maintenance/GetIVIShipDepartmentList', {});
  }
  getBlobUrl() {
    return this.http.get(Helper.API_URL() + '/api/Maintenance/GetBlobStorageUrl');
  }
  getUserImageBlobPath() {
    return this.http.get(Helper.API_URL() + '/api/security/GetUserImageBlobPath');
  }

  getAppSettings(settingName: string) {
    return this.http.get(Helper.API_URL() + '/api/Maintenance/GetAppSettings/' + settingName);
  }

  //indexDB
  getShipDetailsIndxDb(shipId: number): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.dbxService.openDatabase().then(db => {
        const tx = db.transaction('OWS_tblShips', 'readwrite');
        let store = tx.objectStore('OWS_tblShips');
        store.get(shipId).then((res: any) => {
          resolve(res);
        })
      })
    })
    return promise;
  }
  saveShipDetailsIndxDb(shipInfo: any) {
    this.dbxService.openDatabase().then(db => {
      const tx = db.transaction('OWS_tblShips', 'readwrite');
      let store = tx.objectStore('OWS_tblShips');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      store.clear();
      try {
        store.add(shipInfo);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
    });
  }
  saveUser(userID: string, userInfo: any) {
    const obj = {
      userID: userID,
      userInfo: userInfo,

    };

    this.dbxService.openSecurityDatabase().then(db => {
      const tx = db.transaction('OWS_UserInfo', 'readwrite');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      try {
        tx.objectStore('OWS_UserInfo').add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }

      return tx.done;// complete;
    });
  }

  getUserInfo(ID: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openSecurityDatabase().then(db => {
        const tx = db.transaction('OWS_UserInfo', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_UserInfo');
        store.get(ID).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveTrustedCode(userName: string, trustedCode: string) {
    const obj = {
      userName: userName,
      trustedCode: trustedCode
    };

    this.dbxService.openSecurityDatabase().then(db => {
      const tx = db.transaction('OWS_tblTrustedMachine', 'readwrite');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      try {
        tx.objectStore('OWS_tblTrustedMachine').add(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
      return tx.done;// complete;
    });
  }
  updateTrustedCode(userName: string, trustedCode: string) {
    const obj = {
      userName: userName,
      trustedCode: trustedCode
    };

    this.dbxService.openSecurityDatabase().then(db => {
      const tx = db.transaction('OWS_tblTrustedMachine', 'readwrite');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      try {
        tx.objectStore('OWS_tblTrustedMachine').put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
      return tx.done;// complete;
    });
  }
  getTrustedCode(userName: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openSecurityDatabase().then(db => {
        const tx = db.transaction('OWS_tblTrustedMachine', 'readwrite');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblTrustedMachine');
        store.get(userName).then(
          (res: any) => {
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  saveIsAuthenticated(userName: string, isAuth: any) {
    const obj = {
      userName: userName,
      isAuthenticated: isAuth
    };

    this.getIsAuthenticated(userName).then((res: any) => {

      if (res != null) {
        this.updateIsAuthenticated(userName, isAuth);
      }
      else {
        this.dbxService.openSecurityDatabase().then(db => {
          const tx = db.transaction('OWS_IsAuthenticated', 'readwrite');
          tx.onabort = (event: any) => {
            const err = event.target?.error;
            if (err?.name === 'QuotaExceededError') {
              this.handleQuotaExceeded();
            }
          };

          tx.onerror = (event: any) => {
            console.warn(event);
            const err = event.target?.error;
            if (err?.name === 'QuotaExceededError') {
              this.handleQuotaExceeded();
            }
          };

          try {
            tx.objectStore('OWS_IsAuthenticated').add(obj);
          } catch (e: any) {
            if (e?.name === 'QuotaExceededError') {
              this.handleQuotaExceeded();
            }
          }

          return tx.done;// complete;
        });
      }
    });
  }
  updateIsAuthenticated(userName: string, isAuth: any) {
    const obj = {
      userName: userName,
      isAuthenticated: isAuth
    };

    this.dbxService.openSecurityDatabase().then(db => {
      const tx = db.transaction('OWS_IsAuthenticated', 'readwrite');
      tx.onabort = (event: any) => {
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      tx.onerror = (event: any) => {
        console.warn(event);
        const err = event.target?.error;
        if (err?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      };

      try { 
        tx.objectStore('OWS_IsAuthenticated').put(obj);
      } catch (e: any) {
        if (e?.name === 'QuotaExceededError') {
          this.handleQuotaExceeded();
        }
      }
      return tx.done;// complete;
    });
  }
  getIsAuthenticated(userName: string): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      this.dbxService.openSecurityDatabase().then(db => {
        const tx = db.transaction('OWS_IsAuthenticated', 'readonly');
        tx.oncomplete = (ev) => {
        }
        tx.onerror = (err: any) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_IsAuthenticated');
        store.get(userName).then(
          (res: any) => {
            if (res != null)
              resolve(res.isAuthenticated);
            else
              resolve(res);
          }
        )
        // return tx.done;// complete;
      });

    });
    return promise;
  }

  isBlobfileExist(filename: any) {
    let paramObject = {
      'filename': filename
    }
    return this.http.post(Helper.API_URL() + '/api/Maintenance/CheckBlobfileExist', paramObject);
  }

  hasRoleAccess(moduleAccessID: number) {

    let paramObject = {
      'moduleAccessID': moduleAccessID
    }

    return this.http.post(Helper.API_URL() + '/api/Security/HasRoleAccess', paramObject)
      .pipe(
        map((res: any) => res.entity)
      );
  }

  getNavigationItems() {

    const key = `NavigationItems_${SecurityHelper.GetLoggedInUserData().userID}`;

    if (this.onlineOfflineService.isOnline) {
      // Online: Fetch data from the API
      return this.http.get(Helper.API_URL() + '/api/Security/GetNavigationItems')
        .pipe(
          tap((res: any) => {
            // Store the response in IndexedDB for offline use
            this.pushNavigationItemsToIndexedDB(key, res);
          }),
          map((res: any) => res)
        );
    } else {
      // Offline: Retrieve data from IndexedDB
      let res = this.getNavigationItemsFromIndexedDB(key);
      console.log('offline nav', res);
      //return of(res);
      return from(res);
    }
  }

  pushNavigationItemsToIndexedDB(key: string, dataList: any): Promise<{ status: string; message: string; error?: any }> {

    const data = { ID: key, refList: dataList };

    return this.dbxService.openDatabase()
      .then(db => {
        const transaction = db.transaction('OWS_tblReferenceList', 'readwrite');
        const store = transaction.objectStore('OWS_tblReferenceList');
        transaction.onabort = (event: any) => {
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };

        transaction.onerror = (event: any) => {
          console.warn(event);
          const err = event.target?.error;
          if (err?.name === 'QuotaExceededError') {
            this.handleQuotaExceeded();
          }
        };
        let isUpdate = false;

        return store.get(data.ID)
          .then(existingItem => {
            isUpdate = !!existingItem;
            return isUpdate ? store.put(data) : store.add(data);
          })
          .then(() => transaction.done) //wait for transaction to finish 
          .then(() => ({
            status: 'success',
            message: isUpdate ? 'Data updated successfully.' : 'Data added successfully.'
          }))
          .catch(error => ({
            status: 'error',
            message: 'Error processing data.',
            error
          }))
        //.finally(() => transaction.done);
      })
      .catch(error => ({
        status: 'error',
        message: 'Error opening database.',
        error
      }));
  }

  getNavigationItemsFromIndexedDB(key: string): Promise<any> {
    return this.dbxService.openDatabase()
      .then(db => {
        const transaction = db.transaction('OWS_tblReferenceList', 'readonly');
        const store = transaction.objectStore('OWS_tblReferenceList');
        return store.get(key).then(record => record?.refList || []);
      })
      .catch(error => {
        console.error('Error retrieving data from IndexedDB:', error);
        return [];
      });
  }

  getRecaptchaKey() {
    return this.http.post(Helper.API_URL() + '/api/General/GetRecaptchaKey', {});
  }

  handleQuotaExceeded() {
    swal
      .fire({
        title: 'Error',
        html: '<span>IndexedDB storage qouta exceeded.</span>',
        icon: "error",
        confirmButtonText: "OK",
        allowOutsideClick: false,
        allowEscapeKey: false,
      })
      .then((result) => {
        if (result.value) {
        }
      });
  }

  //Index db
  putBaselURLRefIndexdb(ID: any, refType: any, stringValue: any) {
    const obj = {
      ID: ID,
      refType: refType,
      settingValue: stringValue,
    };
    this.dbxService.openDatabase().then(db => {
      //console.log('this.idbContext().then');
      const tx = db.transaction('OWS_tblReferenceList', 'readwrite');
      tx.oncomplete = (ev) => {

      }
      tx.onerror = (err) => {
        console.warn(err);
      }
      let store = tx.objectStore('OWS_tblReferenceList');
      let req = store.put(obj);

      return tx.done;// complete;
    });
  }

  getBaselURLRefIndexdb(appSettingsID: any): Promise<Object> {
    let promise: any = new Promise((resolve) => {

      this.dbxService.openDatabase().then(db => {
        //console.log('this.idbContext().then');
        const tx = db.transaction('OWS_tblReferenceList', 'readwrite');
        tx.oncomplete = (ev) => {
          console.log('tx.oncomplete');
        }
        tx.onerror = (err) => {
          console.warn(err);
        }
        let store = tx.objectStore('OWS_tblReferenceList');
        store.get(appSettingsID).then(
          (res: any) => {
            //console.log(res);
            resolve(res);
          }
        )
        // return tx.done;// complete;
      });
    });
    return promise;
  }

}
